import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { f3Animations } from '@f3/animations';
import { map, Subject } from 'rxjs';
import { CasualHireFormService } from '../casual-hire-form.service';
import { Step } from '../form-step.type';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'hire-form-navigation-button',
    templateUrl: './navigation-button.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: f3Animations,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButton]
})
export class HireFormNavigationButtonComponent implements OnInit, OnDestroy {

	@Input() public stepTitle: string = ''
	@Input() public display: boolean = true;
	@Input() public stepIsValid = <boolean | null>false;
    @Output() readonly clicked: EventEmitter<boolean> = new EventEmitter<boolean>();

	// @Private Properties
	private _unsubscribeAll: Subject<any> = new Subject;


	/**
	 * Constructor
	 * @param _formStepperService 
	 */
	constructor(
		private _changeDetectorRef: ChangeDetectorRef,
		private _casualHireFormService: CasualHireFormService,
		private _activatedRoute: ActivatedRoute
	) { }

	/**
	 * On Init
	 */
	ngOnInit(): void {

		this._casualHireFormService.currentStepValid$.pipe(
            map((value) => {
                this.stepIsValid = value;

                this._changeDetectorRef.detectChanges()

            })
        ).subscribe()

	}

	/**
	 * On Destroy
	 */
	ngOnDestroy(): void {
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete()
	}


	//--------------------------------------------------------------------------------
	// @Public Methods
	//--------------------------------------------------------------------------------

	public buttonClicked() {
		this._casualHireFormService.goToNextStep(this._activatedRoute)
	}

	/**
	 * 
	 */
	public nextStep(): Step | null {
        return this._casualHireFormService.getNextStep();
    }
	
	

	
}
